module.exports = __webpack_public_path__ + "img/bg.a75619e8.webp";